const CX_USERS = {
    GETTTING_ALL_USERS: 'GETTING_ALL_USERS',
    GET_ALL_USERS_SUCCESS: 'GET_ALL_USERS_SUCCESS',
    GET_ALL_USERS_FAILURE: 'GET_ALL_USERS_FAILURE',
}

export default CX_USERS;